import React, {useEffect} from "react";
import styles from "./SimpleSentence.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeUp, faPause } from "@fortawesome/free-solid-svg-icons";
import LessonInstruction from "../../containers/instruction/LessonInstruction";
import useAudioPlayback from "../../hooks/useAudioPlayback";

const SimpleSentence = ({ data, audioUrl }) => {

  const { state, togglePlayback} = useAudioPlayback(audioUrl, "simple_sentence");

  const handlePlayPause = () => {
    togglePlayback();
  };

  const showContent = (type) => {
    if (data && data.type) {
      if (type === "instruction") {
        return (
          <LessonInstruction
            instructionText={data.instruction}
            audioUrl={audioUrl}
          />
        );
      }

      return (
        <div className={styles.simple_sentence_container}>
          <div className={"title-container"}>
            <div className={styles.audio_container} onClick={handlePlayPause}>
              <div className={styles.audio_icon_container}>
                {state === 'playing' ? (
                  <FontAwesomeIcon
                    className={styles.audio_icon}
                    size={"2x"}
                    icon={faPause}
                  />
                ) : (
                  <FontAwesomeIcon
                    className={styles.audio_icon}
                    size={"2x"}
                    icon={faVolumeUp}
                  />
                )}
              </div>
            </div>
          </div>
          <h2 className={styles.simple_sentence_text_content}>
            {data.pt.length > 0 && data.pt !== "#" ? data.pt : data.en}
          </h2>
        </div>
      );
    }

    return <></>;
  };

  return data && data.type ? (
    <div className="default-card default-card-full-width">
      {showContent(data.type)}
    </div>
  ) : (
    <div className="default-card">Template não configurado</div>
  );
};

export default SimpleSentence;
